<template>
  <div class="w-100">
    <img
      class="w-100"
      src="@/assets/new-design/images/no-review-submitted.png"
      alt=""
    />
  </div>
</template>
